import React, {Component} from 'react';
import {Link, withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import user_group_L from "../../../assets/images/user_group_L.png";
import {getChatlist, updateReadChat} from "../../../actions/chatAction";
import iconPath from "./../../../helpers/iconHelper";
import { getlanguagelist } from "../../../helpers/changelanguage";
import './ChatBox.css';

class ChatBox extends Component {

  constructor(props) {
    super(props);
    this.state = {
      chatUser     : [],
      search_text  : null,
      spin         : true,
      serchchat    : '',
      chatlistAPICall : false,
      readchatAPICall : false

    };
  
    this.getChatlist = this.getChatlist.bind(this);
    this.viewChat    = this.viewChat.bind(this);
    this.openApp     = this.openApp.bind(this);
    this.serchChat   = this.serchChat.bind(this);
  }

  componentDidMount() {
    this.getChatlist();
   /*  if(window.location.href.includes('feed')){
      setInterval(this.getChatlist, 15000);
    }
 */
   
  }

  getChatlist(){
    let param = {
      search     : this.state.serchchat,
    }
    this.setState({
      chatlistAPICall : true
    })
    //console.log('Call Feed page api');
    this.props.getChatlist(param);
  }
  serchChat(e){
    this.setState({
        [e.target.name]: e.target.value,
    },function(){

      if(this.state.serchchat.length >= 3) 
      {
          this.getChatlist();
      }
      if(this.state.serchchat == '') 
      {
          this.getChatlist();
      }
     
    });
  }
  viewChat(user){
    //this.props.history.push(`/chat/${user.chat_id}`);
    if((user.view_status == 0) && (user.receiver == 'receiver')){
      let param = {sender_id : user.chat_id,
                   timestamp : Math.floor(Date.now() / 1000)
                  };

      this.setState({
        readchatAPICall : true
      })
                  
      this.props.updateReadChat(param);
    }else{
      //console.log(user.chat_id == '' ? user.receiver : user.chat_id);
      this.props.history.push(`/chat/${user.chat_id == '' ? user.receiver : user.chat_id }`);
    } 
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if(nextProps.chatlist != this.props.chatlist){
      if(this.state.chatlistAPICall === true){
        //console.log('Calling again..');
        this.setState({
          chatUser    : nextProps.chatlist,
          spin        : false,
          chatlistAPICall : false
        })
      }
      
    }else if(nextProps.readchat != this.props.readchat){
      if(this.state.readchatAPICall === true){
        this.setState({
          readchatAPICall : false
        })
        this.props.history.push(`/chat/${nextProps.readchat.sender_id}`);
      }
    }
    if(nextProps.listOfFeed != this.props.listOfFeed){
      //this.getChatlist();
    }
    /* if((nextProps.chatsearch != this.props.chatsearch) && (nextProps.chatsearch != null)){
      this.setState({
        search_text : nextProps.chatsearch
      },function(){
        this.getChatlist();
      })
    } */
  }

  openApp(){
    $("#appModal").modal('show');
  }

  render() {
    let  languagelist = getlanguagelist();
    return (
      <div className="post_box known">
      <h3><b>{languagelist.chat} </b>
        {
          (this.state.spin == true) ? <i className='fa fa-spinner fa-spin'></i>  : null
        }
        
      <a className="box_heading_lnk" style={{cursor : 'pointer'}} href={void(0)} onClick={()=> this.viewChat(0)}>{languagelist.seeall}</a>
      </h3>
      <ul className="live_friend_list">
                  <li>
                    <input 
                      placeholder={languagelist.searchafrnd} 
                      className="search_chat" 
                      type="text" 
                      className="search_chat" 
                      name="serchchat" 
                      value={this.state.serchchat} 
                      onChange={this.serchChat}
                    />
                  </li>
         { this.state.chatUser.map((user,index) => {
              return(
                <li className={(user.view_status == '0') ? "unread" : ""} key={`chat${index}`} onClick={()=> this.viewChat(user)}>
                  <div className="list_ico">
                  {
                    (user.image_name != '') ? 
                    <img 
                      className={(user.chat_membership == 'GOLD') ? "gold_user" : ""} 
                      src={user.image_name} 
                      onError = {(e) => {
                        e.target.src = iconPath['DEFAULTUSER']
                      }} 
                    /> 
                    : <img src={iconPath['DEFAULTUSER']}/>
                  } 

                  </div>
                  <div className="list_details">
                    <h4>{user.chat_name} 
                      {/* <span className="live_icon online"></span> */}
                    </h4>
                    {(user.chat_id != 0)  ?
                      <p>{user.mutual_friend} mutual friend</p> 
                      : null
                    }
                    
                  </div>
                </li>
              )
              
           })
         }
      </ul>
      <div className="clearfix"></div>
      <div className="post_box_footer">
        <img src={user_group_L} />
        <a className="box_heading_lnk" href={void(0)} style={{cursor : 'pointer'}} onClick={this.openApp}>{languagelist.groupchat}</a>
        <div className="clearfix"></div>
      </div>
    </div>
    );
  }

}

const mapStateToProps = state => {
  return {
    chatlist   : state.chatuserlist.chatList.list, 
    readchat   : state.readchat.readChat, 
    chatsearch : state.chatsearch.chatSearch,
    listOfFeed : state.listfeed, 
  }

}

const mapDispatchToProps = dispatch => {
  return {
    getChatlist    : bindActionCreators(getChatlist, dispatch),
    updateReadChat : bindActionCreators(updateReadChat, dispatch),
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ChatBox));